<template>
  <vh-form class="sign-form-wrap" :rules="rules" :model="form" ref="form" label-width="96px">
    <vh-form-item :label="$t('host.k_595001')">
      <vh-radio-group v-model="form.pushType">
        <vh-radio :disabled="!isLiving" :label="0">
          {{ $t('host.k_595002') }}
        </vh-radio>
        <vh-radio :label="1">{{ $t('host.k_595003') }}</vh-radio>
      </vh-radio-group>
      <div v-if="form.pushType == 1" class="view-record-wrapper">
        <vh-button type="text" size="medium" round @click="$emit('viewList')">
          {{ $t('host.k_595075') }}
        </vh-button>
      </div>
      <p class="tips" v-if="form.pushType == 0">{{ $t('host.k_595004') }}</p>
    </vh-form-item>

    <template v-if="form.pushType == 1">
      <!-- 第一个签到时间 -->
      <vh-form-item :key="`pushTimes_0`" class="push-time" :label="$t('host.k_595005')">
        <div class="push-time-row">
          <vh-date-picker
            :append-to-body="false"
            class="inline_input"
            v-model="form.pushTimes[0]"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :pickerOptions="pickerOptions"
            size="small"
            type="datetime"
            :placeholder="$t('host.k_595006')"
            round
          ></vh-date-picker>
        </div>
        <span class="push-time-suffix">{{ $t('host.k_595007') }}</span>
        <p class="time_tips">{{ $t('host.k_595008') }}</p>
      </vh-form-item>
      <!-- 添加签到时间按钮（固定一行，放在额外时间列表前面） -->
      <vh-form-item label="" class="push-time-add">
        <vh-button
          type="text"
          class="btn-add-time"
          :disabled="form.pushTimes.length >= 20"
          @click="addPushTime"
        >
          {{ $t('host.k_595059') }}
        </vh-button>
      </vh-form-item>
      <!-- 额外签到时间（横向排列，自动换行） -->
      <vh-form-item v-if="form.pushTimes.length > 1" label=" " class="push-time-extra">
        <div class="push-time-wrap">
          <div
            v-for="(time, index) in form.pushTimes.slice(1)"
            :key="`pushTimes_${index + 1}`"
            class="push-time-item"
          >
            <vh-date-picker
              :append-to-body="false"
              class="inline_input"
              v-model="form.pushTimes[index + 1]"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              :pickerOptions="pickerOptions"
              size="small"
              type="datetime"
              :placeholder="$t('host.k_595006')"
              round
            ></vh-date-picker>
            <i
              class="vh-iconfont vh-line-remove-outline btn-del-time"
              @click="removePushTime(index + 1)"
            ></i>
          </div>
        </div>
      </vh-form-item>
    </template>
    <vh-form-item :label="$t('host.k_595009')">
      <vh-autocomplete
        popper-class="sign-tips-autocomplete"
        class="form-input"
        :maxlength="15"
        show-word-limit
        ref="custom_title"
        :fetch-suggestions="querySearch('custom_title')"
        v-model="form.signTip"
      >
        <template slot-scope="{ item }">
          <div v-if="item.id == -2" @click.stop="editCustom('1')" class="name" :key="item.id">
            {{ querySearchRes.custom_title.length > 11 ? '' : item.content }}
          </div>
          <div v-else-if="item.id >= 0" class="name" :key="item.id">
            {{ item.content }}
            <div class="tips-ctr">
              <vh-button type="text" @click.stop="editCustom('1', item)">
                {{ $t('host.k_595010') }}
              </vh-button>
              <vh-button type="text" @click.stop="delCustomTips(item.id)">
                {{ $t('host.k_595011') }}
              </vh-button>
            </div>
          </div>
          <div v-else class="name" :key="item.id">{{ item.content }}</div>
        </template>
      </vh-autocomplete>
    </vh-form-item>
    <vh-form-item :label="$t('host.k_595012')">
      <vh-select class="form-input" v-model="form.duration" popper-class="sign-select">
        <vh-option
          v-for="(opt, idx) in durationOps"
          :key="idx"
          :label="opt.label"
          :value="opt.value"
          class="sign-form-wrap-select"
        ></vh-option>
      </vh-select>
    </vh-form-item>
    <vh-form-item label=" " v-show="form.duration == -1" prop="custom">
      <vh-input
        class="form-input"
        :placeholder="$t('host.k_595013')"
        style="width: auto"
        v-model="form.custom"
        :maxlength="4"
      ></vh-input>
      {{ $t('host.k_595014') }}
    </vh-form-item>
    <vh-form-item :label="$t('host.k_595015')">
      <vh-autocomplete
        class="form-input"
        popper-class="sign-tips-autocomplete"
        :maxlength="15"
        show-word-limit
        ref="custom_success_tips"
        :fetch-suggestions="querySearch('custom_success_tips')"
        v-model="form.signInsuccessTips"
      >
        <template slot-scope="{ item }">
          <div v-if="item.id == -2" @click.stop="editCustom('2')" class="name" :key="item.id">
            {{ querySearchRes.custom_success_tips.length > 11 ? '' : item.content }}
          </div>
          <div v-else-if="item.id >= 0" class="name" :key="`${item.id}_1`">
            {{ item.content }}
            <div class="tips-ctr">
              <vh-button type="text" @click.stop="editCustom('2', item)">
                {{ $t('host.k_595010') }}
              </vh-button>
              <vh-button type="text" @click.stop="delCustomTips(item.id)">
                {{ $t('host.k_595011') }}
              </vh-button>
            </div>
          </div>
          <div v-else class="name" :key="`${item.id}_2`">{{ item.content }}</div>
        </template>
      </vh-autocomplete>
    </vh-form-item>

    <vh-form-item :label="$t('host.k_595016')">
      <vh-switch
        v-model="form.sound_status"
        active-color="#FB3A32"
        :active-value="1"
        :inactive-value="0"
      ></vh-switch>
      <span style="overflow-wrap: break-word; word-break: normal">
        {{ !!form.sound_status ? $t('host.k_595017') : $t('host.k_595018') }}
      </span>
      <div class="trial-sound">
        <vh-button type="text" @click="handleTrialSound">{{ $t('host.k_595019') }}</vh-button>
        <vh-tooltip placement="right">
          <div class="sign-form-wrap-tip" slot="content" style="background: #333">
            <div>{{ $t('host.k_595020') }}</div>
            <div>{{ $t('host.k_595021') }}</div>
          </div>
          <i class="vh-iconfont vh-line-question" style="margin-left: 4px"></i>
        </vh-tooltip>
        <TrialSound ref="audioTrialSound" />
      </div>
    </vh-form-item>

    <vh-form-item class="kick-out" :label="$t('host.k_595022')">
      <vh-switch
        class="kick-switch"
        v-model="form.auto_kick_unsigned"
        active-color="#FB3A32"
        :active-value="1"
        :inactive-value="0"
        :active-text="
          (!!form.auto_kick_unsigned ? $t('host.k_595023') : $t('host.k_595024')) +
          $t('host.k_595025')
        "
      ></vh-switch>
    </vh-form-item>
    <vh-form-item
      v-if="form.pushType == 0"
      class="automatic-checkin-item"
      :label="$t('host.k_595026')"
    >
      <vh-switch
        @change="autoSignChange"
        v-model="form.autoSign"
        active-color="#FB3A32"
        :active-text="!!form.autoSign ? $t('host.k_595027') : $t('host.k_595028')"
      ></vh-switch>
    </vh-form-item>
    <vh-form-item
      v-if="form.pushType == 0"
      :label="$t('host.k_595029')"
      v-show="form.autoSign"
      class="formm-item--interval"
    >
      <vh-select class="form-input" v-model="form.intervalValue" popper-class="sign-select">
        <vh-option
          v-for="(opt, idx) in intervalOps"
          :key="idx"
          :label="opt.label"
          :value="opt.value"
          class="select-option"
        ></vh-option>
      </vh-select>
      <vh-tooltip placement="right" class="form-input-tip">
        <div class="sign-form-wrap-tip" slot="content" style="background: #333">
          <div>{{ $t('host.k_595030') }}</div>
        </div>
        <i class="vh-iconfont vh-line-question" style="padding-left: 6px; line-height: 40px"></i>
      </vh-tooltip>
    </vh-form-item>
    <vh-form-item
      label=" "
      v-if="form.pushType == 0 && form.intervalValue == -1 && form.autoSign"
      prop="intervalCustom"
      class="formm-item--interval"
    >
      <vh-input
        class="form-input"
        v-model="form.intervalCustom"
        :placeholder="$t('host.k_595031')"
        style="width: auto; width: 200px"
      >
        <template slot="append">{{ $t('host.k_595032') }}</template>
      </vh-input>
    </vh-form-item>
    <vh-form-item class="sign-form-wrap-start">
      <vh-button
        type="primary"
        size=""
        round
        class="sign-form-wrap-start-btn"
        @click="handleSubmit"
      >
        {{ isLiving ? $t('host.k_595033') : $t('host.k_595034') }}
      </vh-button>
    </vh-form-item>

    <vh-dialog
      :visible.sync="showEditTips"
      width="400px"
      class="sign_tips"
      append-to-body
      :title="$t('host.k_595035')"
      top="25vh"
    >
      <div>
        <vh-input
          :rows="4"
          ref="tipsInput"
          :placeholder="$t('host.k_595036')"
          v-model="curEditTips.content"
          maxlength="15"
          show-word-limit
        ></vh-input>
      </div>
      <span slot="footer">
        <vh-button
          type="primary"
          @click="saveCustomTips"
          :disabled="!curEditTips.content"
          size="medium"
          round
        >
          {{ $t('host.k_595037') }}
        </vh-button>
        <vh-button type="default" @click="showEditTips = false" size="medium" round>
          {{ $t('host.k_595038') }}
        </vh-button>
      </span>
    </vh-dialog>
  </vh-form>
</template>

<script>
  import regRule from '@/app-shared/utils/reg-rule.js';
  import { throttle } from 'lodash';
  import { useSignServer } from 'middle-domain';
  import TrialSound from '@/app-shared/components/trial-sound/index.vue';
  export default {
    name: 'SigninSet',
    components: { TrialSound },
    data() {
      return {
        defaultText: this.$t('host.k_595039'),
        defaultResTipText: this.$t('host.k_595040'),
        form: {
          pushType: 0, // 签到推送方式，1：手动，2：定时
          signTip: this.$t('host.k_595039'), // 签到提示语
          duration: 30, // 签到显示的时间，单位秒，
          signInsuccessTips: this.$t('host.k_595040'), // 签到成功提示语,
          autoSign: false, // 是否自动发起签到，1自动，0取消自动
          intervalValue: 5, // 自动发起签到的轮询定时时间，单位秒
          intervalCustom: 5,
          custom: 90,
          sound_status: 0, // 提示音效开关
          auto_kick_unsigned: 0, //未签到踢出直播间，1开启，0关闭
          pushTimes: [''] //定时推送时间列表
        },
        durationOps: [
          {
            value: 10,
            label: this.$t('host.k_595041')
          },
          {
            value: 30,
            label: this.$t('host.k_595042')
          },
          {
            value: 60,
            label: this.$t('host.k_595043')
          },
          {
            value: 120,
            label: this.$t('host.k_595044')
          },
          {
            value: 180,
            label: this.$t('host.k_595045')
          },
          {
            value: -1,
            label: this.$t('host.k_595046')
          }
        ],

        intervalOps: [
          // {
          //   value: 60,
          //   label: '1分钟'
          // },
          {
            value: 5,
            label: this.$t('host.k_595047')
          },
          {
            value: 15,
            label: this.$t('host.k_595048')
          },
          {
            value: 30,
            label: this.$t('host.k_595049')
          },
          {
            value: -1,
            label: this.$t('host.k_595046')
          }
        ],

        showEditTips: false, //提示语编辑弹框
        curEditTips: {
          id: undefined,
          content: ''
        },
        querySearchRes: {},
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      };
    },
    computed: {
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      }
    },
    created() {
      this.rules = {
        // pushTimes 的验证在 submit 方法中统一处理
        custom: {
          validator: (rule, value, callback) => {
            console.log(
              this.form.duration == -1 &&
                regRule.positiveInt0.test(value) &&
                value >= 10 &&
                value <= 9999
            );
            if (
              !(
                this.form.duration != -1 ||
                (this.form.duration == -1 &&
                  regRule.positiveInt0.test(value) &&
                  value >= 10 &&
                  value <= 9999)
              )
            ) {
              callback(new Error(this.$t('host.k_595051')));
            } else if (
              this.form.autoSign &&
              ((this.form.duration != -1 && this.form.duration >= this.form.interval) ||
                (this.form.duration == -1 && this.form.custom >= this.form.interval))
            ) {
              callback(new Error(this.$t('host.k_595052')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        },
        intervalCustom: {
          validator: (rule, value, callback) => {
            // 使用正则验证5-120的整数
            const regex = /^(5|6|7|8|9|10|[1-9]\d|1[0-1]\d|120)$/;
            if (!regex.test(value)) {
              return callback(new Error(this.$t('host.k_595053')));
            }
            callback();
          },
          trigger: 'blur'
        }
      };
      this.signServer = useSignServer();
    },
    mounted() {
      if (this.isLiving) {
        this.form.pushType = 0;
      } else {
        this.form.pushType = 1;
      }
    },
    methods: {
      querySearch(type) {
        return (queryString, cb) => {
          cb('');
          this.signServer.getSignCustomTips().then(res => {
            if (res.code == 200) {
              res.data.custom_title.unshift({
                id: -1,
                content: this.defaultText
              });

              res.data.custom_title.push({
                id: -2,
                content: this.$t('host.k_595054')
              });
              res.data.custom_success_tips.unshift({
                id: -1,
                content: this.defaultResTipText
              });

              res.data.custom_success_tips.push({
                id: -2,
                content: this.$t('host.k_595054')
              });
              this.querySearchRes = res.data;
              cb(
                res.data[type].map(item => {
                  item.value = item.content;
                  return item;
                })
              );
            }
          });
        };
      },
      autoSignChange(value) {
        console.warn('test----自动签到  改变值', value);
        // window.sessionStorage.setItem('isAutoSign', value)
      },
      addPushTime() {
        if (this.form.pushTimes.length >= 20) {
          this.$vhMessage.warning(this.$t('host.k_595060'));
          return;
        }
        // 找到最后一个已填的日期时间
        const filledTimes = this.form.pushTimes.filter(t => t);
        if (filledTimes.length === 0) {
          this.form.pushTimes.push('');
          return;
        }
        const lastTime = filledTimes[filledTimes.length - 1];
        // 使用 replace 将 - 替换为 / 以兼容 Safari
        const date = new Date(lastTime.replace(/-/g, '/'));
        if (isNaN(date.getTime())) {
          this.form.pushTimes.push('');
          return;
        }
        date.setMinutes(date.getMinutes() + 15);
        const pad = n => String(n).padStart(2, '0');
        const newTime = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
          date.getDate()
        )} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
        this.form.pushTimes.push(newTime);
      },
      removePushTime(index) {
        this.form.pushTimes.splice(index, 1);
      },
      handleSubmit: throttle(
        function () {
          this.$refs.form.validate(valid => {
            if (valid) {
              // 验证 pushTimes
              if (this.form.pushType == 1) {
                const filledTimes = this.form.pushTimes.filter(t => t);

                // 检查是否有空值
                if (filledTimes.length !== this.form.pushTimes.length) {
                  this.$vhMessage.error(this.$t('host.k_595050'));
                  return;
                }

                // 检查是否有重复时间
                const duplicate = filledTimes.some(
                  (time, index) => filledTimes.indexOf(time) !== index
                );
                if (duplicate) {
                  this.$vhMessage.error(this.$t('host.k_595061'));
                  return;
                }
              }

              const data = Object.assign({}, this.form, {
                duration: this.form.duration != -1 ? this.form.duration : Number(this.form.custom),
                interval:
                  (this.form.intervalValue != -1
                    ? this.form.intervalValue
                    : Number(this.form.intervalCustom)) * 60,
                push_times: this.form.pushTimes.filter(t => t).join(',')
              });
              this.$emit('start', data);
            }
          });
        },
        2000,
        { trailing: false }
      ),
      editCustom(type, item) {
        this.curEditTips = {
          id: item?.id,
          content: item?.content,
          type
        };
        this.showEditTips = true;
        this.$nextTick(() => {
          this.$refs.custom_success_tips.activated = false;
          this.$refs.custom_title.activated = false;
        });
      },
      async saveCustomTips() {
        if (
          (this.curEditTips.type == 1 && this.curEditTips.content == this.$t('host.k_595039')) ||
          (this.curEditTips.type == 1 && this.curEditTips.content == this.$t('host.k_595040'))
        ) {
          this.$vhMessage.error(this.$t('host.k_595055'));
          return;
        }

        const res = await (!this.curEditTips.id
          ? this.signServer.createSignCustomTips(this.curEditTips)
          : this.signServer.editSignCustomTips(this.curEditTips));
        if (res.code == 200) {
          this.showEditTips = false;
          this.curEditTips.type == 1
            ? (this.form.signTip = this.curEditTips.content)
            : (this.form.signInsuccessTips = this.curEditTips.content);
          this.$vhMessage.success(this.$t('host.k_595056'));
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      async delCustomTips(id) {
        const res = await this.signServer.delSignCustomTips({ id });
        if (res.code == 200) {
          this.$vhMessage.success(this.$t('host.k_595057'));
          this.$refs.custom_title.$data.suggestions =
            this.$refs.custom_title.$data.suggestions.filter(el => el.id !== id);
          this.$refs.custom_success_tips.$data.suggestions =
            this.$refs.custom_success_tips.$data.suggestions.filter(el => el.id !== id);
          this.querySearchRes.custom_title = this.querySearchRes.custom_title.filter(
            el => el.id !== id
          );
          this.querySearchRes.custom_success_tips = this.querySearchRes.custom_success_tips.filter(
            el => el.id !== id
          );
        } else {
          this.$vhMessage.error(res.msg);
        }
      },
      // 试听
      handleTrialSound() {
        this.$refs['audioTrialSound']?.play();
      }
    }
  };
</script>
<style lang="less" scoped>
  .tips-ctr {
    float: right;
  }
  .inline_input {
    width: 176px;
    vertical-align: middle;
  }
  .tips {
    line-height: 20px;
    font-size: 12px;
    color: #262626;
  }
  .time_tips {
    font-size: 13px;
    line-height: 20px;
    color: #f62626;
    white-space: normal;
    word-break: break-word;
    overflow-wrap: break-word;
    margin-top: 4px;
  }
  .push-time-row {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .push-time-suffix {
    margin-left: 4px;
  }
  .push-time-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
    overflow: visible;
  }
  .push-time-item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .btn-del-time {
    color: #f62626;
    cursor: pointer;
  }
</style>
<style lang="less">
  .sign-form-wrap {
    margin: 0 auto;

    .view-record-wrapper {
      position: absolute;
      top: 0;
      right: 10px;
    }
    .vh-form-item {
      margin-right: 0;
      width: 100%;
      .vh-form-item__content {
        width: calc(100% - 96px);
        .form-input {
          width: 100%;
          &-tip {
            position: absolute;
            left: 100%;
          }
        }
      }
    }
    .vh-form-item.push-time {
      margin-bottom: 2px;
    }
    .vh-form-item.push-time-add {
      margin-bottom: 6px;
    }
    .vh-form-item.formm-item--interval {
      .vh-form-item__content {
        width: calc(100% - 96px);
      }
    }
    .vh-switch {
      margin-right: 5px;
      height: 16px;
      line-height: 16px;
      &__core {
        width: 28px !important;
        height: 16px;
        flex-shrink: 0;
      }
      &__core:after {
        width: 12px;
        height: 12px;
      }
      .vh-switch__label--right * {
        line-height: 20px;
      }

      &.kick-switch {
        .vh-switch__label span {
          color: #fb2626;
        }
      }
    }

    .trial-sound {
      display: inline-block;
      vertical-align: middle;
      margin-left: 10px;
    }

    .vh-switch.is-checked .vh-switch__core::after {
      margin-left: -13px;
    }
    &-select {
      line-height: 40px !important;
      &:hover {
        background-color: #f7f7f7;
      }
      &.hover {
        font-weight: normal;
        background: none;
      }
      &:hover {
        background-color: #f7f7f7;
      }
      &.selected {
        background-color: #f7f7f7;
        font-weight: normal;
        color: #606266;
      }
    }
    &-tip {
      line-height: 18px;
      font-size: 12px;
      width: 238px;
      font-weight: 400;
      color: #ffffff;
      line-height: 18px;
    }
    &-start {
      text-align: right;
      padding-top: 24px;

      &-btn {
        min-width: 120px;
      }
    }
    .vh-iconfont {
      color: #999;
      font-size: 14px;
    }
    .vh-form-item.is-success {
      .vh-input__inner {
        border-color: #e2e2e2;
      }
    }
  }
  .sign-tips-autocomplete {
    li {
      padding: 0;
      & > div {
        padding: 0 10px;
      }
    }
  }

  // 乐乐&直播带货布局下，签到添加时间样式调整
  // .sign-live2 {
  //   .sign-live2__body {
  //     .vh-form.sign-form-wrap .vh-form-item.push-time-extra {
  //       .vh-form-item__content {
  //         margin-left: 60px !important;
  //         width: calc(100% - 60px) !important;

  //         .push-time-wrap .push-time-item .inline_input {
  //           width: 160px;
  //         }
  //       }
  //     }
  //   }
  // }
</style>
